<template>
    <div class="p-20px">
        <div class="flex items-center justify-between">
            <div class="w-25px h-25px mr-5px flex items-center justify-center" @click="handleBack">
                <img src="@/assets/images/mine/left.webp" class="w-full h-full" />
            </div>
            <div class="text-16px color-#fff font-900 text-center">
                Chat Model
            </div>
            <div class="w-25px  mr-5px flex items-center justify-center">

            </div>
        </div>
        <div>
            <div class="gems flex items-center justify-center mb-15px">
                Gems
            </div>
            <div class="flex overflow-x-auto gap-10px">
                <div class="bg-01 overflow-hidden rounded-10px w-260px flex-shrink-0 relative"
                    :class="{ 'active': selectedId === value.id }" v-for="value in modeNotViplList"
                    @click="handleSelect(value)">
                    <div class="bg-03 p-10px text-15px font-800">
                        {{ value.title }}
                    </div>
                    <div class="text-12px p-10px ">
                        <div class="pb-30px">
                            {{ value.description }}
                        </div>
                        <div class="flex items-center bg-#01031B rounded-10px p-2px w-80px justify-center">
                            <img src="@/assets/images/chat/chatRecord/shuijing.svg" alt="" class="w-6px h-10px">
                            <div class="color-#ABB6FF text-10px ml-2px">{{ value.cost }}/Message</div>
                        </div>
                    </div>
                    <div class="absolute bottom-0 right-0 w-20px" v-if="selectedId === value.id">
                        <img src="@/assets/images/chat/chatRecord/check.webp" alt="" class="w-full h-full">
                    </div>

                </div>
            </div>
        </div>
        <div>
            <div class="pro flex items-center justify-center mb-15px">
                Pro
            </div>
            <div class="flex overflow-x-auto gap-10px">
                <div class="bg-01 overflow-hidden rounded-10px w-260px flex-shrink-0 relative"
                    :class="{ 'active': selectedId === value.id }" v-for="value in modeViplList"
                    @click="handleSelect(value)">
                    <div class="bg-03 p-10px text-15px font-800">
                        {{ value.title }}

                    </div>
                    <div class="text-12px p-10px ">
                        <div class="pb-30px">
                            {{ value.description }}

                        </div>
                        <!-- <div class="flex items-center bg-#01031B rounded-10px p-2px w-80px justify-center">
                            <img src="@/assets/images/chat/chatRecord/shuijing.svg" alt="" class="w-6px h-10px">
                            <div class="color-#ABB6FF text-10px ml-2px">6/Message</div>
                        </div> -->
                    </div>
                    <div class="absolute bottom-0 right-0 w-20px" v-if="selectedId === value.id">
                        <img src="@/assets/images/chat/chatRecord/check.webp" alt="" class="w-full h-full">
                    </div>

                </div>
            </div>
        </div>
        <div class="btn" @click="handleSave">
            Save
        </div>
    </div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router'
import { MessageAPI } from '@/services/message'
import { ref, onMounted } from 'vue'
import { showSuccessToast, showLoadingToast, showErrorToast } from '@/utils/toast'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/user'
const { t } = useI18n()
const modeViplList = ref<any[]>([])
const modeNotViplList = ref<any[]>([])
const selectedId = ref<string | number>('')
const selectedItem = ref<any>(null)
const userStore = useUserStore()
const handleSelect = (item: any) => {
    if(![4,5].includes(userStore.userInfo.role)) {
        router.push({
            path: '/vip',
            query: {
                type: 'u',
                tab: 'chat',
                isModel: 'true'
            }
        })
        return
    }
    if (selectedId.value === item.id) return
    selectedId.value = item.id
    selectedItem.value = item
}

const handleSave = async () => {
    try {
        showLoadingToast()
        if (!selectedItem.value) return
        await MessageAPI.setUserChatModel({
            chatModelId: selectedItem.value.id,
        })
        showSuccessToast(t('message.successfulSwitch'), { duration: 1000 })
        router.back()
    } catch (error) {
        console.error('Failed to save model:', error)
        showErrorToast(t('message.saveModelFailed'), { duration: 1000 })
    }

}

const router = useRouter()
const handleBack = () => {
    router.back()
}
const getModelList = async () => {
    const res = await MessageAPI.modelList({})
    modeViplList.value = res.data.filter((item: any) => item.isVipSee === 1)
    modeNotViplList.value = res.data.filter((item: any) => item.isVipSee === 0)
    const defaultItem = res.data.find((item: any) => item.isChecked)
    if (defaultItem) {
        selectedId.value = defaultItem.id
        selectedItem.value = defaultItem
    }
}
onMounted(() => {
    getModelList()
})
</script>
<style scoped lang="scss">
.gems {
    margin-top: 36px;
    background: linear-gradient(90deg, #E1EC7B 0%, #53B134 100%);
    border-radius: 23px;
    font-weight: 800;
    font-size: 16px;
    color: #1F3417;
    padding: 2px 4px;
    width: 64px;
    height: 28px;
}

.pro {
    margin-top: 36px;
    background: linear-gradient(90deg, #E9D6FF 0%, #A66CFE 100%);
    border-radius: 23px;
    font-weight: 800;
    font-size: 16px;
    color: #490D73;
    padding: 2px 4px;
    width: 64px;
    height: 28px;
}

.bg-01 {
    width: 260px;
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid transparent;
}

.bg-03 {
    width: 260px;
    background-color: rgba(255, 255, 255, 0.03);
    border: 1px solid transparent;
}

.btn {
    position: absolute;
    bottom: 10px;
    width: 89%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 11px 0;
    background: linear-gradient(0deg, #5A68FF 0%, #95A5FF 100%);
    border-radius: 23px;
    font-weight: 800;
    font-size: 16px;
    color: #FFFFFF;
}

.active {
    border: 1px solid #5A68FF;
}
</style>